import { PortionMaterialSizeDescriptionField } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, TextOutput } from '../../../../../Core';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../Layout';
import { IWorksheetComponent } from '../../../../Core';

let FinePortionSievingMassesSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const isWashed = useSelector(pipe(createWorksheetSelector!('Washing.IsWashed'), valueOrDefault(false)));
  return (
    <ListFieldSection>
      <PortionMaterialSizeDescriptionField />
      {isWashed ? (
        <Field input={<TextOutput />} name="Washing.WashedDryMass" label="Sieve Portion Washed Material Dry Mass" />
      ) : (
        <Field input={<TextOutput />} name="Masses.DryMass" label="Sieve Portion Material Dry Mass" />
      )}
      <Field input={<TextOutput />} name="Masses.MassUpscaleFactor" />
    </ListFieldSection>
  );
};
FinePortionSievingMassesSection = withInjectedProps(FinePortionSievingMassesSection);

export { FinePortionSievingMassesSection };
export default FinePortionSievingMassesSection;
